import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { SelectWrapper } from "./styles";

const Select = (props) => {
	const {
		placeholder,
		errorMessages,
		options,
		optionDisplayKey,
		optionValueKey,
		emitFocusEvent,
		isRequired,
		value,
		showError,
		emitChangeEvent,
	} = props;
	const listHeight = "auto";
	const isScrollable = false;
	const [selectedItem, setSelectedItem] = useState(null);
	const [showDropdown, _setShowDropdown] = useState(false);
	const showDropdownRef = React.useRef(showDropdown);
	const dropdownRef = React.useRef(null);
	const setShowDropdown = (data) => {
		showDropdownRef.current = data;
		_setShowDropdown(data);
	};
	const toggleDropdown = () => {
		setShowDropdown(!showDropdown);
	};
	const selectItem = (item) => {
		// TODO: set value in parent
		// this.parentForm.controls[this.controlName].setValue(item[this.optionValueKey]);
		// this.emitChangeEvent.emit(item);
		emitChangeEvent(item);
		setSelectedItem(item);
		toggleDropdown();
	};
	const hideDropdown = () => {
		setShowDropdown(false);
	};
	const handleOutsideClick = (event) => {
		// not working... not able to select
		const isNestedElement =
			dropdownRef.current && dropdownRef.current.contains(event.target);
		if (!isNestedElement && showDropdownRef.current) {
			hideDropdown();
			// this.emitBlurEvent.emit();
		}

		// TODO might be needed to show error msg..
		// if (this.showDropdown) {
		//   this.parentForm.controls[this.controlName].markAsTouched();
		//   this.emitFocusEvent.emit();
		// }
	};
	useEffect(() => {
		//TODO add event listners on
		// @HostListener('document:click', ['$event'])
		// @HostListener('document:touchstart', ['$event'])
		// also remember to remove them when component is removed
		window.addEventListener("click", handleOutsideClick);
		window.addEventListener("touchstart", handleOutsideClick);

		// cleanup this component
		return () => {
			window.removeEventListener("click", handleOutsideClick);
			window.removeEventListener("touchstart", handleOutsideClick);
		};
	}, []);

	return (
		<SelectWrapper
			ref={dropdownRef}
			onClick={() => {
				emitFocusEvent();
			}}
		>
			<div className={`dropdown`}>
				<div
					className={`dropdown-text ${
						selectedItem ? "dropdown-selected" : "dropdown-not-selected"
					} ${showDropdown ? "list-open" : ""} ${
						options.length <= 1 ? "no-list" : ""
					}`}
					onClick={() => {
						toggleDropdown();
					}}
				>
					{selectedItem ? selectedItem[optionDisplayKey] : placeholder}
				</div>
				{/* TODO: check effect of control.touched in below span 
          also span had attr (focus)="control.markAsUntouched()"
        */}
				{errorMessages && !selectedItem && !showDropdown && showError && (
					<span>
						<i className="form-control-error-icon fa fa-exclamation-circle"></i>
						{isRequired && (
							<label className="select-error select-error-pos">
								{errorMessages["required_error_message"]}
							</label>
						)}
					</span>
				)}

				<div className={`list-container`}>
					{showDropdown && (
						<ul
							className={`dropdown-list ${listHeight ? "height" : ""} ${
								isScrollable ? "scrollable-list" : ""
							}`}
						>
							{options.map((option, index) => {
								return !selectedItem ||
									option[optionValueKey] !== selectedItem[optionValueKey] ? (
									<li
										onClick={(e) => {
											selectItem(option);
										}}
										key={`list-item-${index}`}
									>
										{option[optionDisplayKey]}
									</li>
								) : null;
							})}
						</ul>
					)}
				</div>
			</div>
		</SelectWrapper>
	);
};

Select.propTypes = {
	placeholder: PropTypes.string,
	errorMessages: PropTypes.object,
	options: PropTypes.array.isRequired,
	optionDisplayKey: PropTypes.string.isRequired,
	optionValueKey: PropTypes.string.isRequired,
	emitFocusEvent: PropTypes.func.isRequired,
	isRequired: PropTypes.bool,
	value: PropTypes.object,
};

// todo reCheck for default values
Select.defaultProps = {
	placeholder: "",
	errorMessages: {},
	options: [],
	optionDisplayKey: "",
	optionValueKey: "",
	emitFocusEvent: () => {},
	isRequired: false,
	value: "",
};

export default Select;
